module.exports = __webpack_public_path__ + "static/media/close.93a24585.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/ui/close.svg
// module id = 170
// module chunks = 0